import React, { ReactNode } from 'react';
import classNames from 'classnames/bind';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

interface TabBarWrapperProps {
  children: ReactNode;
  style?: React.CSSProperties;
}

export const TabBarWrapper: React.FC<TabBarWrapperProps> = ({ children, style }) => {
  return (
    <div className={cx('wrapper')} style={style}>
      {children}
    </div>
  );
};
